let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kFzNV")).then(() => parcelRequire('7YOHo'));